import { render, staticRenderFns } from "./HostingInfo.vue?vue&type=template&id=f0b2a934&"
import script from "./HostingInfo.vue?vue&type=script&lang=js&"
export * from "./HostingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports